<script lang="ts">import { cfgBrandTitle, cfgToThemeContentPath } from "@infinitro/config";
import { locale, loggedIn } from "@infinitro/global";
import CdnSeoMarkdownPanel from "./cdn-seo-markdown-panel.svelte";
import { applyStaticSeoPlaceholders, fetchLocaleRawWithEnFallback, renderSeoMarkdown } from "./fetch-markdown-seo";
export let showMoreButton = true;
export let withBackground = false;
export let noContainer = false;
export let section;
const BRAND_NAME = cfgBrandTitle();
let htmlContent = "";
let lastModified = "";
$: sec = section || "home";
$: loc = $locale;
$: if ($loggedIn === false && sec) {
	const localeUrl = cfgToThemeContentPath(`/seo/${sec}/${sec}.${loc}.md`);
	const enUrl = cfgToThemeContentPath(`/seo/${sec}/${sec}.en.md`);
	const capturedSec = sec;
	const capturedLoc = loc;
	fetchLocaleRawWithEnFallback(localeUrl, enUrl, { cacheBust: true }).then(({ raw, lastModified: lm }) => {
		if (capturedSec !== sec || capturedLoc !== $locale || $loggedIn !== false) return;
		const withPlaceholders = applyStaticSeoPlaceholders(raw, BRAND_NAME);
		htmlContent = renderSeoMarkdown(withPlaceholders);
		lastModified = lm;
	});
} else {
	htmlContent = "";
	lastModified = "";
}
$: hasContent = htmlContent.trim().length > 0;
</script>

<svelte:head>
	{#if lastModified}
		<meta property="article:modified_time" content={lastModified} />
	{/if}
</svelte:head>

{#if $loggedIn === false && hasContent}
	<CdnSeoMarkdownPanel
		{htmlContent}
		{lastModified}
		{showMoreButton}
		{withBackground}
		{noContainer}
	/>
{/if}
